// Fields that can supply a page's og:image, in order of preference.
// Volto reads opengraph_image, then config.settings.contentMetadataTagsImageField,
// which Volto Light Theme sets to preview_image; news items only have a lead image.
export const SHARE_IMAGE_FIELDS = ['opengraph_image', 'preview_image', 'image'];

/** The first image field on the content with a large scale, or null. */
export function shareImage(content) {
  const field = SHARE_IMAGE_FIELDS.find(
    (name) => content?.[name]?.scales?.large?.download,
  );
  return field ? content[field] : null;
}
